import React from 'react';
import { AppDialog } from '../shared/AppDialog';
import { FieldBlock, FieldLabel, FieldInput } from '../shared/AppDialogField';
import { CreditCardIcon } from '../shared/Icons';

/** Collects the CRM lead details a payment needs before the gateway opens. */

export interface LeadContactField {
  /** Key in the contact record, e.g. "firstName". */
  name: string;
  label: string;
  required: boolean;
  type: 'text' | 'email' | 'tel';
}

interface LeadContactDialogProps {
  open: boolean;
  fields: LeadContactField[];
  values: Record<string, string>;
  onValueChange: (name: string, value: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
}

const LeadContactDialog: React.FC<LeadContactDialogProps> = ({
  open,
  fields,
  values,
  onValueChange,
  onCancel,
  onConfirm,
}) => (
  <AppDialog
    open={open}
    onClose={onCancel}
    icon={<CreditCardIcon />}
    title="Complete your details"
    subtitle="We need these details to create your lead before opening secure payment."
    actions={[
      { label: 'Cancel', onClick: onCancel, variant: 'secondary' },
      { label: 'Continue', onClick: onConfirm },
    ]}
  >
    {fields.map((field) => (
      <FieldBlock key={field.name}>
        <FieldLabel htmlFor={`lead-${field.name}`}>
          {field.label}
          {field.required && <span> *</span>}
        </FieldLabel>
        <FieldInput
          id={`lead-${field.name}`}
          type={field.type}
          value={values[field.name] || ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onValueChange(field.name, e.target.value)
          }
        />
      </FieldBlock>
    ))}
  </AppDialog>
);

export default LeadContactDialog;
